import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useGetEasyPayBuyerTransactionsQuery } from 'services/api/transactions';
import { setPage } from 'services/transactions/transactionsSlice';
import TransactionRecordCard from '../components/TransactionRecordCard';

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const LoadMoreButton = styled.button`
  margin: 16px auto;
  display: block;
  padding: 10px 32px;
  background: #005a96;
  color: #fff;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 48px;
  color: #666;
  font-size: 16px;
`;

const EasyPayTab = () => {
  const { page, perPage } = useSelector((state: any) => state.transactions.easyPay);
  const { data, isFetching } = useGetEasyPayBuyerTransactionsQuery({ limit: perPage, offset: page });
  const dispatch = useDispatch();

  const transactions = useMemo(
    () => data?.rows?.ids?.map((id: any) => data?.rows?.entities?.[id]) ?? [],
    [data]
  );
  const transactionsCount = useMemo(() => data?.count ?? 0, [data]);

  const loadMore = () => {
    if (perPage * page >= transactionsCount) return;
    dispatch(setPage({ page: page + 1, tab: 'easyPay' }));
  };

  const canLoadMore = perPage * page < transactionsCount;

  if (!isFetching && transactions.length === 0) {
    return <EmptyState>No Easy Pay transactions found.</EmptyState>;
  }

  return (
    <>
      <ListWrapper>
        {transactions.map((vehicle: any) => (
          <TransactionRecordCard
            key={vehicle.id}
            vehicle={vehicle}
            queryEndpoint="getEasyPayBuyerTransactions"
            reduxTab="easyPay"
          />
        ))}
      </ListWrapper>
      {canLoadMore && (
        <LoadMoreButton onClick={loadMore} disabled={isFetching}>
          {isFetching ? 'Loading...' : 'Load More'}
        </LoadMoreButton>
      )}
    </>
  );
};

export default EasyPayTab;
